export default function About() {
    return (
        <section id="about" className="about-section section">
            <div className="container">
                <div className="about-content">
                    {/* Teks Tentang Kami */}
                    <div className="about-text">
                        <h2 className="section-title">About Us</h2>
                        <p>
                            <span className="highlight">PT. Innovatech Digi Eravision</span> adalah perusahaan yang bergerak di bidang sistem integrasi IT, Audio Visual, Automation. Kami berfokus pada penyediaan solusi teknologi yang terintegrasi dan disesuaikan dengan kebutuhan setiap klien. Tidak hanya menghadirkan produk berkualitas tinggi, kami juga memberikan pengalaman menyeluruh melalui desain interior 3 dimensi yang yang memungkinkan klien melihat gambaran jelas tentang penerapan perangkat dalam ruang yang sebenarnya.
                        </p>
                    </div>

                    {/* Gambar Tentang Kami */}
                    <div className="about-image">
                        <img src="/images/about.jpg" alt="Smart Office" />
                    </div>
                </div>
            </div>
        </section>
    );
}
